<template>
  <div id="app">
 
    <WWHeader />
    <div class="contentArea">
    <router-view/>
    </div>
    <WWFooter />
  </div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.contentArea{
  width:90vw;margin:auto;
  min-height:50vh;
}
</style>
<script>
import WWHeader from '@/components/UI/header.vue'
import WWFooter from '@/components/UI/footer.vue'

export default {
  name: 'Home',
  mounted:function(){

  },
  components: {
    WWHeader,
    WWFooter
  },
  methods:{
   
  },
}
</script>